export default __webpack_public_path__ + "static/media/business_show_1_en.5cbd6ef4.png";